/* eslint-disable @scandipwa/scandipwa-guidelines/jsx-no-conditional */
/* eslint-disable react/no-unknown-property */
import { PropTypes } from 'prop-types';
import React, { PureComponent } from 'react';

import Loader from 'Component/Loader';

import './Unsubscribe.style.scss';

/** @namespace Scandipwa/Route/Unsubscribe/Component */
export class UnsubscribeComponent extends PureComponent {
    static propTypes = {
        isLoading: PropTypes.string.isRequired,
        isUnsubscribed: PropTypes.string
    };

    static defaultProps = {
        isUnsubscribed: false
    };

    renderMessage() {
        const { isUnsubscribed } = this.props;

        if (isUnsubscribed) {
            return <h1>{ __('You were unsubscribed') }</h1>;
        }

        return <h1>{ __('You have already unsubscribed') }</h1>;
    }

    renderContent() {
        return (
            <>
                { this.renderMessage() }
                <a
                  block="Button"
                  href="/"
                >
                    { __('Back to homepage') }
                </a>
            </>
        );
    }

    render() {
        const { isLoading } = this.props;

        return (
            <div
              block="Unsubscribe"
            >
                { isLoading
                    ? <Loader isLoading={ isLoading } />
                    : this.renderContent() }
            </div>
        );
    }
}

export default UnsubscribeComponent;
